import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const PLATFORM_LABELS = {
  "ps5": "PS5",
  "ps4": "PS4",
  "switch 1": "Switch 1",
  "switch 2": "Switch 2",
  "xbox": "Xbox",
  "pc": "PC",
  "multi": "Multi",
};

export function formatPlatform(platform) {
  if (!platform) return "";
  return PLATFORM_LABELS[platform.toLowerCase()] ?? platform;
}

export function getYouTubeId(url) {
  if (!url) return null;
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : null;
}

export function formatDateDisplay(value) {
  if (!value) return "";

  const [datePart] = String(value).split("T");
  const isoMatch = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return `${day}-${month}-${year}`;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}
